<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7'}" id="outermost">
      <van-nav-bar
            title="跟进记录"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
            id="topbar"
        />
      <div style="padding:20px">
        <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              :immediate-check="false"
              >
                <div v-for="(item,index) in followRecordsList" :key="index" class="record">
                  <div style="padding:0px 20px;border-bottom:1px solid #EBEEF5;">

                    <van-row class="infoRow" align="center">
                        <van-col span="6">跟进人：</van-col>
                        <van-col>{{item.followUserName}}</van-col>
                    </van-row>

                    <van-row class="infoRow" align="center">
                      <van-col span="6">跟进凭证：</van-col>
                      <van-col>
                        <img :src="apiUrl+'download/'+item.attId" width="200" v-if="item.attId">
                        <span v-else>无</span>
                      </van-col>
                    </van-row>

                    <van-row class="infoRow" type="flex" style="align-items:center">
                        <van-col span="6">跟进日期：</van-col>
                        <van-col>{{item.followDate}}</van-col>
                    </van-row>

                    <van-row class="infoRow" align="center">
                        <van-col span="6">记录内容：</van-col>
                        <van-col span="18">{{item.followRecord}}</van-col>
                    </van-row>

                  </div>
                </div>
        </van-list>
      </div>
      <div style="position: fixed;bottom: 0px;width: 100%;">
          <van-button block color="#1B75F6" native-type="button" @click="addRecord">添加记录</van-button>
      </div>
    </div>
</template>
<script>
    import $ from '@/fly'
    import Setting from '@/setting';
    import Vue from 'vue';
    import { ImagePreview } from 'vant';

    Vue.use(ImagePreview);
    export default {
        name: 'project-problemFollowRecords',
        data () {
            return {
                clientHeight: window.screen.height,
                followRecordsList: [],
                loading: false,
                finished: false,
                apiUrl: Setting.apiBaseURL,
                problemName: ''
            }
        },
        computed: {
        },
        methods: {
            addRecord () {
                this.$router.push({ name: 'project-addProblemFollowRecord' });
            }
        },
        mounted () {
            var that = this;
            $.get('problemFollow/getNoPage', {
                problemId: localStorage.getItem('problemId')
            }).then(res => {
                that.followRecordsList = res;
                // 加载状态结束
                that.loading = false;
                that.finished = true;
            })
        }
    }

</script>

<style lang="less" scoped>
  .van-search__content{
    border: 1px solid #8da0eb;
  }
  .record{
    background-color:#FFFFFF;
    margin-bottom: 20px;
  }
  .typeTxt{
      font-size:30px;
      font-weight:bold;
      border-bottom: 1px solid #EBEEF5;
      padding: 25px 0px 15px 0px;
      letter-spacing: 1px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }
  .typeTxt span{
      width:5px;
      background-color:#50C9FF;
      display:inline-block;
      height: 34px;
      vertical-align:middle;
  }
  .infoRow{
      padding:15px 5px;
      font-size: 26px;
      font-weight: bold;
  }
  .infoRow .van-col:nth-child(1){
      color: #999999;
  }
  .btnDiv{
    padding:40px;
  }
  .btnDiv button{
    width: 100%;
    height: 60px;
    line-height: 60px;
    border-radius: 5px;
  }
</style>
